import type { FC } from 'react';
import { lazy } from 'react';
import { useMemoOne } from 'use-memo-one';
import type { MmsParams, UmmsOverviewParams } from 'src/apis/iip-service/types';
import type { IipServiceRequest } from 'src/apis/iip-service/use-iip-service';
import { useMms } from 'src/apis/iip-service/use-mms';
import { useUmms } from 'src/apis/iip-service/use-umms';
import { PageSpinner } from 'src/components/spinner-container';
import type { Successful } from 'src/hooks/use-axios';
import { useMmPageParams } from 'src/pages/market-messages/maintenance-messages/overview/use-page-params';
import { useUmmsPageParams } from 'src/pages/market-messages/urgent-market-messages/overview/use-page-params';

const Page = lazy(() => import('./page'));

type Props = {
  iipService: Successful<IipServiceRequest>;
};

export const UrgentMarketMessagesCreate: FC<Props> = ({ iipService }) => {
  const params = useUmmsPageParams();
  const transformedParams = useMemoOne<UmmsOverviewParams>(() => {
    const { start, pageSize, marketParticipantIds, ...rest } = params.value;
    return {
      offset: start,
      limit: 0,
      marketParticipantIds: marketParticipantIds.map(
        (marketParticipant) => marketParticipant.value
      ),
      ...rest,
    };
  }, [params.value]);
  const umms = useUmms({ iipService, params: transformedParams });

  const mmParams = useMmPageParams();
  const transformedMMParams = useMemoOne<MmsParams>(() => {
    const { start, pageSize, tsoOperatorId, ...rest } = mmParams.value;
    return {
      offset: start,
      limit: pageSize,
      tsoOperatorId: tsoOperatorId.map((item) => item.value),
      ...rest,
    };
  }, [params.value]);

  const mms = useMms({ iipService, params: transformedMMParams });
  if (!umms.response || !mms.response) return <PageSpinner />;

  return <Page umms={umms} mms={mms} />;
};
